module.exports = __webpack_public_path__ + "static/img/freshman-python-hover.507c310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshman-python-hover.png
// module id = GGhi
// module chunks = 1